import { Injectable } from '@angular/core';
import {
  ActivatedRoute,
  ActivatedRouteSnapshot,
  NavigationEnd,
  Route,
  Router,
} from '@angular/router';
import { urlSegment } from 'src/app/helper/class/url-services';
import {
  isArray,
  replacePlaceholder,
} from 'src/app/helper/class/utilityHelper';
import { urlConfig } from 'src/app/helper/interface/response';
import { AuthService } from 'src/app/helper/service/auth.service';

@Injectable({
  providedIn: 'root',
})
export class NavigationService {
  private history: { url: string; title: string }[] = [];
  constructor(
    private router: Router,
    private auth: AuthService,
    private activeRoute: ActivatedRoute
  ) {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        const currentRoute = this.router.routerState.snapshot.root;
        const skipHistory = this.getSkipHistory(currentRoute);

        if (!skipHistory) {
          const urlWithoutFrg = event.urlAfterRedirects.split('#')[0];
          const lastUrl =
            (this.history[this.history?.length - 1]?.url || '').split('#')[0] ||
            '';

          if (lastUrl !== urlWithoutFrg) {
            this.history.push({ url: event.urlAfterRedirects, title: '' });
          }
        }
      }
    });
  }
  private getSkipHistory(route: ActivatedRouteSnapshot): boolean {
    let r: ActivatedRouteSnapshot | null = route;
    while (r?.firstChild) {
      r = r.firstChild;
    }
    return !!r?.data?.['skipHistory'];
  }

  setLastUrlTitle(title) {
    if (this.history.length)
      this.history[this.history.length - 1].title = title;
  }
  getPreviousUrl() {
    return (
      this.history[this.history?.length - 2] || { url: '/', title: 'Home' }
    );
  }
  back(): void {
    const returnUrl = this.activeRoute.snapshot.queryParams['returnUrl'];
    if (returnUrl) {
      const url: URL = new URL('http://local' + decodeURIComponent(returnUrl));
      const query: any = {};

      if (url.hash) {
        query.fragment = url.hash.replace('#', '');
      }

      if (url.search) {
        const params: Record<string, string> = {};
        url.searchParams.forEach((value, key) => {
          params[key] = value;
        });
        query.queryParams = params;
      }

      this.router.navigate([url.pathname], query);
    } else {
      const url = this.history[this.history.length - 2]?.url || '/';
      this.router.navigateByUrl(url);
    }
  }

  navigate(url, queryparam: any = {}, frg = '') {
    queryparam.returnUrl = this.router.url;
    this.router.navigate([url], {
      queryParams: queryparam || {},
      fragment: frg,
    });
  }
  navigatePageSegment(keyName, subKeyName, queryparam: any = {}, frg = '') {
    const url = urlSegment(keyName, subKeyName);
    this.navigate(url, queryparam, frg);
  }
  navigateByConfig(s: urlConfig, d: any = {}) {
    if (s.keyName) {
      if (s.queryparam) {
        // const regex = /{([^}]+)}/g;
        Object.keys(s.queryparam).forEach((a) => {
          s.queryparam[a] = replacePlaceholder(s.queryparam[a], d);
          // // Replace keys with corresponding values from data object
          // s.queryparam[a] = s.queryparam[a].replace(regex, (match, key) => {
          //   // Check if the key exists in the data object
          //   console.log(key)
          //   if (d.hasOwnProperty(key)) {
          //     return d[key]?.toString(); // Replace with corresponding value
          //   } else {
          //     return match; // Keep the original text if key not found
          //   }
          //});
        });
      }
      this.navigatePageSegment(
        s.keyName,
        s.subKeyName,
        s?.queryparam || {},
        s?.frg || ''
      );
    }
  }

  getParamByPermission(params: any[], moduleName) {
    let q = {};
    if (isArray(params)) {
      let oneSuccess = false;
      params?.forEach((query: any) => {
        if (query.actionName && !oneSuccess) {
          moduleName = query.account_name == 'MY_SELF' ? 'STAFF' : moduleName;
          const p = this.auth.checkPermission(moduleName, query.actionName);
          if (p) {
            oneSuccess = true;
            q = { [query.key]: query.value };
          }
          // else if (query.actionName && query.actionName == 'MY_SELF') {
          //   q = { [query.key]: query.value }
          // }
        } else if (!query.actionName) {
          q = { [query.key]: query.value };
        }
      });
    }
    return q;
  }
}
